import { clientAppSettings } from '../Models/ClientAppSettings';

// TODO: Should not use libraries outside of Intercom.DevPortal
import { readCookie, setCookie } from '../../../Intercom.ReactUI/Utils/Cookies';

const cookieInformed = 'cookie-inform';

export class TrackingCookieConsent {
  private _pageTrackingLoaded: boolean;

  public informed(): boolean {
    return !!readCookie(cookieInformed);
  }

  public markAsInformed() {
    const nextYear = new Date();

    nextYear.setFullYear(nextYear.getFullYear() + 1);

    setCookie({ name: cookieInformed, value: 'true', path: '/', expires: nextYear, secure: true, sameSite: 'none' });
  }

  public loadPageTrackingIfInformed() {
    if (!this.informed() || this._pageTrackingLoaded) { return; }

    this._pageTrackingLoaded = true;

    this.trackClientJSBundle();
    this.trackPageViewViaAppInsights();
  }

  private trackClientJSBundle() {
    const clientJSBundleElement = document.getElementById('clientJsBundle');
    const appInsights = getAppInsights();

    if (clientJSBundleElement && appInsights) {
      appInsights.trackEvent('ClientJsBundle', { src: clientJSBundleElement.getAttribute('src') });
    }
  }

  private trackPageViewViaAppInsights() {
    const appInsights = getAppInsights();

    if (appInsights) {
      appInsights.trackPageView();
    }
  }
}

interface AppInsights {
  trackEvent: (name: string, data: any) => void;
  trackPageView: () => void;
}

function getAppInsights(): AppInsights {
  return window['appInsights'] as AppInsights;
}



// WEBPACK FOOTER //
// ./Client/Utils/TrackingCookieConsent.ts